import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Utility function to format phone numbers
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return '';
  
  // Remove all non-numeric characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Check for UK format (starting with +44 or 44)
  if (cleaned.startsWith('44') || cleaned.startsWith('0')) {
    const ukNumber = cleaned.startsWith('44') ? cleaned.slice(2) : cleaned;
    if (ukNumber.length === 10) {
      return ukNumber.replace(/(\d{3})(\d{3})(\d{4})/, '0$1 $2 $3');
    }
    return phone; // Return original if format unknown
  }
  
  // US/North American format
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return cleaned.replace(/1(\d{3})(\d{3})(\d{4})/, '+1 ($1) $2-$3');
  }
  
  // Return original format if we can't determine the format
  return phone;
}
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Prevents Enter key on <input> elements from submitting multi-field forms.
 * Attach as onKeyDown on <form> elements. Textareas, buttons, and combobox
 * inputs (autocomplete dropdowns) are unaffected.
 */
export function preventEnterSubmit(e: React.KeyboardEvent<HTMLFormElement>) {
  const target = e.target as HTMLElement;
  if (
    e.key === 'Enter' &&
    !e.ctrlKey &&
    !e.metaKey &&
    target.tagName === 'INPUT' &&
    target.getAttribute('role') !== 'combobox'
  ) {
    e.preventDefault();
  }
}
